import { getAuthToken, refreshAuthToken } from "auth/authToken";
import { MainContent } from "components/Layout/components/Content";
import { Header, HeaderProps } from "components/Layout/components/Header/Header";
import { MasterLayout } from "components/Layout/components/MasterLayout";
import { SideBar } from "components/Layout/components/SideBar";
import { SupportedApps } from "config/config";
import { useApp } from "hooks/useApp";
import { useEnsureAuthenticated } from "hooks/useEnsureAuthenticated";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PmgAppEnvironmentProvider = React.lazy(() => import("pmgapp/AppEnvironmentProvider"));
const PmgContent = React.lazy(() => import("pmgapp/PmgContent"));
const PmgMenu = React.lazy(() => import("pmgapp/Menu"));

type PmgAppContainerProps = {
    unauthenticatedHandler: (back: string) => void;
    headerProps: HeaderProps;
};

export const PmgAppContainer = ({ unauthenticatedHandler, headerProps }: PmgAppContainerProps) => {
    const navigate = useNavigate();
    const pmgApp = useApp(SupportedApps.pmg);

    const refreshToken = () => {
        refreshAuthToken().catch((e) => {
            // eslint-disable-next-line no-console
            console.error("Auth error", e);
            navigate("/auth");
        });
    };

    useEffect(refreshToken, [navigate]);

    const hasRole = (_role: string) => {
        return true;
    };

    const ensureAuthenticated = useEnsureAuthenticated();

    const authToken = getAuthToken();

    return (
        pmgApp.isLoaded() && (
            <PmgAppEnvironmentProvider
                authToken={authToken}
                containerVersion={APP_INFO.VERSION}
                configuration={pmgApp.configuration}
                extraTermninalActions={[]}
                ensureAuthenticated={ensureAuthenticated}
                hasRole={hasRole}
                unauthenticatedHandler={unauthenticatedHandler}
            >
                <MasterLayout>
                    <Header appTitle={headerProps.appTitle} username={headerProps.username} userProfile={headerProps.userProfile} />
                    <SideBar>
                        <PmgMenu />
                    </SideBar>
                    <MainContent id="pageContent">
                        <PmgContent />
                    </MainContent>
                </MasterLayout>
            </PmgAppEnvironmentProvider>
        )
    );
};
